var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topstat-counter pr-2"},[_c('h3',{staticClass:"is-size-5"},[_c('strong',[_vm._v(_vm._s(_vm.label))])]),_c('p',{staticClass:"mb-0 is-size-6"},[_c('em',[_vm._v(_vm._s(_vm.value))])])])}
var staticRenderFns = []

export { render, staticRenderFns }